<template>
  <div
    class="modal fade text-body"
    id="changeNameModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="modalTitle">氏名を変更</slot>
          </h5>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-6">
              <label for="last_name" class="form-label">姓</label>
              <input
                v-model="user.last_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.user.last_name.$error }"
                id="last_name"
              />
              <span v-if="v$.user.last_name.$error" class="text-danger small">{{
                v$.user.last_name.$errors[0].$message
              }}</span>
            </div>
            <div class="col-6">
              <label for="first_name" class="form-label">名</label>
              <input
                v-model="user.first_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.user.first_name.$error }"
                id="first_name"
              />
              <span
                v-if="v$.user.first_name.$error"
                class="text-danger small"
                >{{ v$.user.first_name.$errors[0].$message }}</span
              >
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-secondary"
            type="button"
            @click.prevent="formCancel"
          >
            キャンセル
          </button>
          <button
            class="btn btn-dark"
            type="button"
            @click.prevent="formSubmit"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min.js'

export default {
  name: 'ProfileChangeName',
  components: {},

  emits: ['hiddenModal', 'afterSubmit'],

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      modal: null,
      user: {},
      vuelidateExternalResults: {
        user: [],
      },
    }
  },
  computed: {},
  validations() {
    return {
      user: {
        first_name: {
          required: helpers.withMessage('必須項目です', required),
        },
        last_name: {
          required: helpers.withMessage('必須項目です', required),
        },
      },
    }
  },

  mounted() {
    this.modal = new Modal(document.getElementById('changeNameModal'))
    document
      .getElementById('changeNameModal')
      .addEventListener('hidden.bs.modal', () => {
        this.user = {}
        this.$emit('hiddenModal')
      })
  },
  beforeUnmount() {
    this.modal.hide()
  },

  methods: {
    ...mapActions({
      patchData: 'auth/patchData',
    }),
    showModal() {
      this.modal.show()
    },
    async formSubmit() {
      this.v$.$clearExternalResults()
      const result = await this.v$.$validate()
      if (!result) {
        return
      }
      try {
        await this.patchData(this.user)
        await this.$emit('afterSubmit')
        this.v$.$reset()
        this.modal.hide()
      } catch (e) {
        if (e.response.status == 400) {
          // サーバー側の検証エラーを表示
          Object.assign(this.vuelidateExternalResults, {
            user: e.response.data,
          })
        }
      }
    },
    formCancel() {
      this.v$.$reset()
      this.modal.hide()
    },
  },
}
</script>
